/* LA BARRA DEL CATÁLOGO POR CASA NO TAPA LA NAVEGACIÓN (25-sep-2026).

   La casa, en dos apuntes: «que no se muestre hasta arriba, sino sobre la zona
   vacía bajo el nav» y «no debe tapar ni la nav bar ni la promoción de
   lanzamiento».

   La barra es `position:fixed` con `top:10px` (catalogo-casas.css), así que nace
   pegada al borde de la pantalla: al entrar por la puerta de Diseñadores caía
   encima del anuncio y del menú. Aquí se mide DÓNDE TERMINA la navegación en cada
   momento —el anuncio solo se ve con la página arriba del todo, y el encabezado
   se queda pegado al bajar— y se publica en `--cc-tope`. La hoja pone la barra
   justo debajo de esa línea. Se mide en el cuadro de animación y no en cada
   evento de scroll, que son decenas por segundo. */
(function(){
  var raiz = document.documentElement, pedido = false;
  function medir(){
    pedido = false;
    var h = document.querySelector('header');
    if(!h) return;
    var abajo = h.getBoundingClientRect().bottom;
    if(abajo < 0) abajo = 0;
    /* En rutas de categoría (caballero/dama/unisex) el buscador debe quedar
       debajo del banner principal, no taparlo. Mientras el banner esté visible
       se usa su parte inferior; cuando ya se haya desplazado, vuelve a seguir
       al header pegajoso como en el resto del sitio. */
    var body = document.body;
    if(body.classList.contains('ruta') && body.getAttribute('data-ruta') !== 'disenadores'){
      var banner = document.getElementById('topBanner');
      if(banner){
        var bb = banner.getBoundingClientRect().bottom;
        if(bb > abajo) abajo = bb;
      }
    }
    raiz.style.setProperty('--cc-tope', Math.round(abajo) + 'px');
  }
  function pedir(){
    if(pedido) return;
    pedido = true;
    if(window.requestAnimationFrame) requestAnimationFrame(medir);
    else setTimeout(medir, 16);
  }
  window.addEventListener('scroll', pedir, {passive:true});
  window.addEventListener('resize', pedir, {passive:true});
  window.addEventListener('hashchange', pedir);
  if(document.readyState !== 'loading') pedir();
  else document.addEventListener('DOMContentLoaded', pedir);
  /* el anuncio y las fuentes llegan tarde y cambian el alto */
  setTimeout(pedir, 400);
  setTimeout(pedir, 1500);

  /* EN DISEÑADORES, LA BARRA SE QUEDA PUESTA.
     La hoja ya la deja visible en esta ruta, pero el guion de la portada escribe
     las clases `fuera` y `oculta` en cuanto mide, y el buscador nace con ellas
     hasta el primer scroll. Aquí se le quitan en cuanto la barra existe —se pinta
     tarde, cuando el mapa vivo responde— y se le da un latido corto la primera
     vez que se entra, para que la vista la encuentre sin buscarla. */
  var latido = false, yaSalio = false;
  function enDisenadores(){ return /^#\/disenadores/.test(location.hash || ''); }
  function sacarla(){
    if(!enDisenadores() || yaSalio) return;
    var b = document.getElementById('ccBarra');
    if(!b) return;
    b.classList.remove('fuera');
    b.classList.remove('oculta');
    /* UNA VEZ Y YA. Se insistía cada cuarto de segundo, y eso peleaba con el guion
       del sitio: al abrir «Ver colección completa» él esconde la barra para no
       tapar el nombre de la casa, y esto se la volvía a poner encima. Con sacarla
       una sola vez, el buscador aparece al entrar y después manda el sitio. */
    yaSalio = true;
    if(!latido){
      latido = true;
      b.classList.add('recien');
      setTimeout(function(){ b.classList.remove('recien'); }, 2600);
    }
  }
  var vueltas = 0;
  var reloj = setInterval(function(){
    vueltas++;
    sacarla();
    armarPanel();
    if(vueltas > 40) clearInterval(reloj);        /* diez segundos y basta */
  }, 250);
  window.addEventListener('hashchange', function(){
    latido = false; yaSalio = false; vueltas = 0;
    sacarla();
  });

  /* ===================================================================
     EL PANEL DEL BUSCADOR: género, marca de inspiración y notas.

     Al tocar el buscador se abren las tres puertas por las que la gente
     busca un perfume, en pastillas, sin escribir nada. Las tres salen del
     catálogo vivo, no de una lista escrita a mano: las casas se ordenan
     por cuántas fragancias tienen y las notas por cuántas veces aparecen,
     así que el panel se actualiza solo cuando entra producto nuevo.

     Género reutiliza los chips que la barra ya trae —se les da un clic
     programático— para no duplicar la lógica del filtro. Casa y nota
     escriben en el buscador, que ya sabe resolver las dos cosas.
     =================================================================== */
  var ICONOS = {
    nota:   '<circle cx="12" cy="12" r="4"/><circle cx="12" cy="12" r="8.5"/>',
    casa:   '<path d="M10 3h4v3l2 3v12H8V9l2-3V3z"/>',
    atajo:  '<path d="M13 3L5 14h6l-1 7 8-11h-6l1-7z"/>'
  };
  function svg(d){
    return '<svg viewBox="0 0 24 24" aria-hidden="true" class="cc-p-ico">' + d + '</svg>';
  }
  function pastilla(texto, tipo, valor, cuantas){
    return '<button type="button" class="cc-p-pastilla" data-tipo="' + tipo +
           '" data-valor="' + String(valor).replace(/"/g, '&quot;') + '">' + texto +
           (cuantas ? '<b>' + cuantas + '</b>' : '') + '</button>';
  }
  function tira(html){
    return '<div class="cc-p-tira"><button type="button" class="cc-p-flecha izq" aria-label="Anterior">' +
           '<svg viewBox="0 0 24 24"><path d="M15 6l-6 6 6 6"/></svg></button>' +
           '<div class="cc-p-riel">' + html + '</div>' +
           '<button type="button" class="cc-p-flecha der" aria-label="Siguiente">' +
           '<svg viewBox="0 0 24 24"><path d="M9 6l6 6-6 6"/></svg></button></div>';
  }
  function grupo(titulo, icono, dentro){
    return '<div class="cc-p-grupo"><span class="cc-p-tit">' + svg(icono) + titulo + '</span>' +
           dentro + '</div>';
  }
  var CUENTA_CASA = {}, CUENTA_NOTA = {};
  function casasOrdenadas(){
    var CAT = window.VELANTIS_CAT || [], i, c;
    CUENTA_CASA = {};
    for(i = 0; i < CAT.length; i++){
      c = CAT[i] && CAT[i][2];
      if(!c) continue;
      CUENTA_CASA[c] = (CUENTA_CASA[c] || 0) + 1;
    }
    return Object.keys(CUENTA_CASA).sort(function(a, b){ return CUENTA_CASA[b] - CUENTA_CASA[a]; }).slice(0, 18);
  }
  /* Las notas NO se toman del selector del catálogo: ese va alfabético y abre con
     abedul, abrótano y akigalawood, que no le dicen nada a nadie. Se cuentan las
     que más se repiten en el catálogo, que son las que la gente reconoce. */
  function notasOrdenadas(){
    var CAT = window.VELANTIS_CAT || [], i, k, trozos, t;
    CUENTA_NOTA = {};
    for(i = 0; i < CAT.length; i++){
      for(k = 5; k <= 7; k++){
        trozos = String((CAT[i] && CAT[i][k]) || '').split(',');
        for(t = 0; t < trozos.length; t++){
          var n = trozos[t].trim().toLowerCase();
          if(n.length > 2) CUENTA_NOTA[n] = (CUENTA_NOTA[n] || 0) + 1;
        }
      }
    }
    return Object.keys(CUENTA_NOTA).sort(function(a, b){ return CUENTA_NOTA[b] - CUENTA_NOTA[a]; }).slice(0, 16);
  }
  function cap(s){ s = String(s || ''); return s.charAt(0).toUpperCase() + s.slice(1); }

  var panelPuesto = false;
  function armarPanel(){
    if(panelPuesto || !enDisenadores()) return;
    var barra = document.getElementById('ccBarra');
    var q = document.getElementById('ccQ');
    var casas = casasOrdenadas();
    if(!barra || !q || !casas.length) return;      /* el catálogo aún no llega */
    panelPuesto = true;

    var p = document.createElement('div');
    p.className = 'cc-panel';
    p.id = 'ccPanel';
    p.hidden = true;
    var notas = notasOrdenadas();
    p.innerHTML =
      '<p class="cc-p-hola">¿Por dónde quieres empezar?</p>' +
      grupo('Dime a qué quieres oler', ICONOS.nota,
            tira(notas.map(function(n){
              return pastilla(cap(n), 'texto', n, CUENTA_NOTA[n]); }).join(''))) +
      grupo('O dime una casa', ICONOS.casa,
            tira(casas.map(function(c){
              return pastilla(c, 'texto', c, CUENTA_CASA[c]); }).join(''))) +
      '<div class="cc-p-grupo cc-p-pie"><span class="cc-p-tit">' + svg(ICONOS.atajo) + 'Atajos</span>' +
      '<div class="cc-p-riel suelto">' +
      pastilla('Para ella', 'para', 'ella') +
      pastilla('Para él', 'para', 'el') +
      pastilla('Unisex', 'para', 'uni') +
      '<i class="cc-p-corte"></i>' +
      '<button type="button" class="cc-p-pastilla oro" data-tipo="codigo" data-valor="V">' +
      'Traigo un código</button>' +
      '</div></div>';
    barra.appendChild(p);

    function abrir(){ if(!q.value.trim()) p.hidden = false; }
    function cerrar(){ p.hidden = true; }
    q.addEventListener('focus', abrir);
    q.addEventListener('click', abrir);
    /* toda la caja abre, no solo los píxeles del campo de texto */
    var caja = barra.querySelector('.cc-caja');
    if(caja) caja.addEventListener('click', function(e){
      if(e.target.closest('.cc-x')) return;
      q.focus();
      abrir();
    });
    q.addEventListener('input', function(){ if(q.value.trim()) cerrar(); else abrir(); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') cerrar(); });
    document.addEventListener('click', function(e){
      if(p.hidden) return;
      if(barra.contains(e.target)) return;
      cerrar();
    });
    /* al pasar por una pastilla, el propio buscador dice qué va a hacer */
    var leyenda = q.getAttribute('placeholder') || '';
    p.addEventListener('mouseover', function(e){
      var b = e.target.closest && e.target.closest('.cc-p-pastilla');
      if(!b) return;
      var t = b.getAttribute('data-tipo'), v = b.getAttribute('data-valor');
      if(t === 'texto') q.setAttribute('placeholder', 'Buscando ' + v.toLowerCase() + '…');
      else if(t === 'codigo') q.setAttribute('placeholder', 'Escribe el número: V618, V033…');
      else q.setAttribute('placeholder', leyenda);
    });
    p.addEventListener('mouseleave', function(){ q.setAttribute('placeholder', leyenda); });

    p.addEventListener('click', function(e){
      var b = e.target.closest && e.target.closest('.cc-p-pastilla');
      if(b){
        var tipo = b.getAttribute('data-tipo'), valor = b.getAttribute('data-valor');
        if(tipo === 'para'){
          var chip = document.querySelector('#ccFiltros button[data-para="' + valor + '"]');
          if(chip) chip.click();
        }else if(tipo === 'codigo'){
          /* el atajo de la casa: aquí la gente pide por código, no por nombre */
          q.value = 'V';
          q.setAttribute('placeholder', 'Escribe el número: V618, V033…');
          q.focus();
          q.dispatchEvent(new Event('input', {bubbles:true}));
          return;                                   /* el panel se queda, aún no eligió */
        }else{
          q.value = valor;
          q.dispatchEvent(new Event('input', {bubbles:true}));
        }
        q.setAttribute('placeholder', leyenda);
        cerrar();
        return;
      }
      var f = e.target.closest && e.target.closest('.cc-p-flecha');
      if(f){
        var riel = f.parentNode.querySelector('.cc-p-riel');
        if(riel) riel.scrollBy({left: f.classList.contains('izq') ? -260 : 260, behavior:'smooth'});
      }
    });
  }
})();
